import { useState, useEffect } from "react";
import axios from "axios";

// const BASE_URL = "http://localhost:8000/api/proxy";
const BASE_URL = process.env.REACT_APP_API_YEMINUS;
const USER_ID = process.env.REACT_APP_USER_YEMINUS; 
const COMPANY_ID = process.env.REACT_APP_COMPANY_YEMINUS;
const USER_PASSWORD = "*Ap1F4cseL0cim3*+";

const TokenApi = () => {
  const [token, setToken] = useState(null);

  const authenticate = async () => {
    try {
      const response = await axios.post(
        `${BASE_URL}/token`,
        {
          userName: USER_ID,
          password: USER_PASSWORD,
          grant_type: "password",
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      const newToken = response.data.access_token;
      setToken(newToken);
      localStorage.setItem("accessToken", newToken); 
      return newToken;
    } catch (error) {
      console.error("Error al obtener el token:", error);
      return null;
    }
  };

  useEffect(() => {
    const fetchToken = async () => {
      const storedToken = localStorage.getItem("accessToken");
      if (!storedToken) {
        await authenticate();
      } else {
        setToken(storedToken);
      }
    };

    fetchToken();
  }, []);

  return { token, authenticate, COMPANY_ID, USER_ID };
};

export default TokenApi;

